export default "__VITE_ASSET__BBLDH2cc__"